import * as Yup from 'yup';

// #1035 'TT.MM' / 'TT.MM.', 29.02. gibt es nicht jedes Jahr
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const dayMonth = Yup.string()
    .required('Pflichtfeld')
    .test('day-month', 'Bitte als TT.MM. angeben', (value) => {
        const match = /^\s*(\d{1,2})\.(\d{1,2})\.?\s*$/.exec(value || '');
        if (!match) {
            return false;
        }
        const day = Number(match[1]);
        const month = Number(match[2]);
        return month >= 1 && month <= 12 && day >= 1 && day <= DAYS_IN_MONTH[month - 1];
    });

export const administrationSettingSchema = Yup.object().shape({
    furtherAssignmentCheckDaysBaseEmployee: Yup.number().required(),
    furtherAssignmentCheckDaysBaseAgency: Yup.number().required(),
    contractFeeFull: Yup.number().typeError('Pflichtfeld').min(0).required('Pflichtfeld'),
    contractFeeHalfPercent: Yup.number()
        .typeError('Pflichtfeld')
        .min(0)
        .max(100)
        .required('Pflichtfeld'),
    contractLocationShareExpert: Yup.number()
        .typeError('Pflichtfeld')
        .min(0)
        .required('Pflichtfeld'),
    contractLocationShareLight: Yup.number()
        .typeError('Pflichtfeld')
        .min(0)
        .required('Pflichtfeld'),
    christmasCareReminderFrom: dayMonth,
    christmasCareDeadline: dayMonth,
    christmasCareResetOn: dayMonth,
    easterCareReminderFrom: dayMonth,
    easterCareDeadline: dayMonth,
    easterCareResetOn: dayMonth,
});
